module.exports = __webpack_public_path__ + "static/media/background_1.16ea01f0.jpg";